module.exports = __webpack_public_path__ + "img/logohistory-old.2417a93f.jpg";